import { Component, computed, inject, input, output } from '@angular/core';
import type { ModalAction } from '@purolator/ui-kit-angular';
import { ModalComponent, TypographyComponent } from '@purolator/ui-kit-angular';
import { TranslatePipe, TranslationService } from '../../../../core/i18n';

/**
 * Confirmation dialog before cancelling shipment creation from Review & Pay.
 */
@Component({
  selector: 'app-review-cancel-shipment-dialog',
  imports: [ModalComponent, TranslatePipe, TypographyComponent],
  templateUrl: './review-cancel-shipment-dialog.html',
  styleUrl: './review-cancel-shipment-dialog.scss',
})
export class ReviewCancelShipmentDialog {
  private readonly translation = inject(TranslationService);

  readonly open = input(false);
  readonly dismissed = output<void>();
  readonly confirmed = output<void>();

  protected readonly modalTitle = computed(() => {
    this.translation.revision();
    return this.translation.translate('createShipment.reviewAndPay.cancelShipment.title');
  });

  protected readonly actions = computed<ModalAction[]>(() => {
    this.translation.revision();
    return [
      {
        label: this.translation.translate('createShipment.reviewAndPay.cancelShipment.no'),
        variant: 'secondary',
        onClick: () => this.onDismiss(),
      },
      {
        label: this.translation.translate('createShipment.reviewAndPay.cancelShipment.yes'),
        variant: 'primary',
        onClick: () => this.onConfirm(),
      },
    ];
  });

  /**
   * Closes the dialog and keeps the customer on Review & Pay.
   */
  protected onDismiss(): void {
    this.dismissed.emit();
  }

  /**
   * Confirms cancellation and lets the page reset wizard state.
   */
  protected onConfirm(): void {
    this.confirmed.emit();
  }
}
